import { render, staticRenderFns } from "./levels.vue?vue&type=template&id=4a3abd50&scoped=true"
import script from "./levels.vue?vue&type=script&lang=js"
export * from "./levels.vue?vue&type=script&lang=js"
import style0 from "./levels.vue?vue&type=style&index=0&id=4a3abd50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3abd50",
  null
  
)

export default component.exports